<template>
    <div class="b-admin-search__container">
        <div class="b-admin-search__inner">
            <input type="text"
                   v-model="search_string"
                   @keydown.enter="searchByString"
                   :placeholder="trans('search')"
                   class="form-control b-admin-search__input"
            >
        </div>
    </div>
</template>

<script>
    import * as Functions from '../Functions';

    export default {
        props: ['translations'],
        data() {
            return {
                search_string: ''
            };
        },
        created() {
            this.$root.$on('clear-search', () => this.search_string = '');
        },
        methods: {
            trans(name, path = null) {
                return Functions.trans(this.translations, name, path);
            },
            searchByString(event) {
                if (event) event.preventDefault();

                this.$root.$emit('update-table', {search_string: this.search_string, page: 1});
            }
        }
    };
</script>
